import type { QueryKey } from "@tanstack/react-query"
import stableStringify from "json-stable-stringify"

import type { ServiceAction, ServiceEntityKey, ServiceName } from "../types"

/**
 * Create a standardized key array to uniquely identify a single query.
 * @param serviceName A unique identifier for a CRUD grouping of service hooks.
 * @param serviceAction The action types used to categorize the functionality of services.
 * @param options An arbitrary object, interpolated as a string, to make keys unique.
 * @returns A TanStack Query key for the query.
 */
export const createQueryKey = (
  serviceName: ServiceName,
  serviceAction: ServiceAction,
  serviceEntityKey: null | ServiceEntityKey = null,
  // Mass eslint disable @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  serviceOptions: Record<string, any> = {}
): QueryKey => [
  serviceName,
  serviceAction,
  serviceEntityKey ?? null,
  stableStringify(serviceOptions) ?? null,
]
